module.exports = __webpack_public_path__ + "static/media/certificacion.4b63e320.PNG";